<template>

    <span v-if="(!onlyLocal && globalNotificationsCount) || localNotificationsCount" :class="'not-badge ' + className">
        <span :title="title" @click.stop="openNotification" class="badge-item" v-if="!onlyLocal && globalNotificationsCount">
            <b-icon :class="iconClassName" :icon="globalIcon"></b-icon>
            <b-badge variant="success" pill>{{ globalNotificationsCount }}</b-badge>
        </span>

        <span :title="title" v-if="localNotificationsCount" class="badge-item">
            <b-icon class="badge-item" :title="title" :class="iconClassName" :icon="localIcon"></b-icon>
            <b-badge v-if="localNotificationsInfo" variant="primary" pill>{{ localNotificationsInfo }}</b-badge>
            <b-badge v-else-if="localNotificationsCount > 1 || localNotificationsInfo > 0" variant="success" pill>{{ localNotificationsInfo ? localNotificationsInfo : localNotificationsCount }}</b-badge>
        </span>
    </span>

</template>

<script>

/**
 * Tasks object
 */

export default {

  components: {},


  data() {
    return {}
  },

  props: ["className", "iconClassName", "title", "node", "type", "globalIcon", "localIcon", "onlyLocal"],

  // Computed vars
  computed: {

    /**
     * Get global notifications count for task
     */

    globalNotificationsCount() {
      // Get count
      return this.$get("notifications/getNotificationsCount", {
        task_id: this.node.id,
        type: this.type,
        zone: "global"
      });
    },

    /**
     * Get local notifications count for task
     */

    localNotificationsCount() {
      // Get count
      return this.$get("notifications/getNotificationsCount", {
        task_id: this.node.id,
        type: this.type,
        zone: "local"
      });
    },

    /**
     * Get local notifications info
     */

    localNotificationsInfo() {
      // Get count
      const {info} = this.$get("notifications/getNotifications", {
        task_id: this.node.id,
        type: this.type,
        zone: "local"
      });

      // Return node info
      return info;

    },


  },

  methods: {


    /**
     * Open comment notification
     */

    openNotification() {

      // Send emit
      this.$emit('openNotification', this.type);
    },

  }
}

</script>

<style lang="scss">

/* Important not animatiob */
@keyframes important_notification {
/*  0% {transform: translate(0px, 0);}
  10% {transform: translate(0, -3px);}
  20% {transform: translate(0, 3px);}
  30% {transform: translate(0, 0);}*/

  0% {transform: scale(1);}
  10% {transform: scale(0.8);}
  20% {transform: scale(1.3);}
  30% {transform: scale(1);}


}

.not-badge {
  .deadline {
    background: #ff00ff;
  }

  // Personal item icons
  .b-icon {
    width: 20px;
    height: 25px;
    margin-right: 1px;
  }

  // Badge items
  .badge-item {
    cursor: pointer;
    display: inline-block;
    line-height: 20px;
    margin-left: 2px;

    .b-icon {
      width: 20px;
      height: 25px;
    }

    .bi-at, .bi-star, .bi-star-fill
    {animation: 2s linear 5s infinite running important_notification;}
  }

  .badge {
    vertical-align: top;
    margin-left: -10px;
    border: 1px solid white;
  }

}
</style>
